import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import userSagas from './User';
import locationSagas from './Location';
import commonSagas from './Common';
import unitSagas from './Unit';
import realtimeSagas from './Realtime';
import alertSagas from './Alert';
import deviceSagas from './Device';
import settingsSagas from './Settings';
import consumptionSagas from './Consumption';
import dashboardSagas from './Dashboard';
import presenceSagas from './Presence';
import telemetryPollSagas from './TelemetryPolling';
import segmentTrackingSagas from './SegmentTracking'

export default function* rootSaga() {
  yield all([
    authSagas(),
    userSagas(),
    locationSagas(),
    commonSagas(),
    unitSagas(),
    realtimeSagas(),
    alertSagas(),
    deviceSagas(),
    settingsSagas(),
    consumptionSagas(),
    dashboardSagas(),
    presenceSagas(),
    telemetryPollSagas(),
    segmentTrackingSagas(),
  ]);
}
